import { WistiaDialog } from 'global/simple-dialog.src';
/*-----------------------------------------------------------------------------------*/
/* Main
/*-----------------------------------------------------------------------------------*/
$(document).ready(function () {
    // video
    var selectors = {
            panelPlay: '[data-selector="video-panel-play"]',
            panelVideo: '[data-selector="video-panel-wrap"]',
            panelClose: '[data-selector="video-panel-close"]',
            play: '[data-selector="video-play"]',
            video: '[data-selector="video-wrap"]',
            close: '[data-selector="video-close"]',
        },
        movie = '';

    // initial full height
    calcHeight();

    // on resize
    $(window).resize(function () {
        calcHeight();
    });

    // go to anchors
    $('.anchor-link').on('click', function (e) {
        e.preventDefault();
        goToAnchor($(this));
    });

    //wistia
    [].forEach.call(document.querySelectorAll('.wistia-trigger'), function (btnElem) {
        var dialogElem = document.getElementById(btnElem.getAttribute('data-dialog-id')),
            wistiaDialog = new WistiaDialog(dialogElem);

        btnElem.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            wistiaDialog.show();
        });
    });

    // FUNCTIONS ------------------------------------------------------------------------------//
    function calcHeight() {
        if ($(window).height() > 867 && $(window).width() > 767) {
            var height = $(window).height() - barsHeight();
            $('.full-height').css('height', height);
        }
    }
    function barsHeight() {
        return $('.rheader').outerHeight() + $('.free-trial').outerHeight();
    }
    function goToAnchor(link) {
        var toId = link.attr('href').replace('#', '');
        var scroll = $('[data-anchor="' + toId + '"]').offset().top - $('.rheader').outerHeight();
        $('html,body').animate({ scrollTop: scroll }, 'slow');
    }
});
